import i18next from 'i18next';
import de from './de.json';
import en from './en.json';
import es from './es.json';

i18next.addResourceBundle('en', 'translation', en);
i18next.addResourceBundle('de', 'translation', de);
i18next.addResourceBundle('es', 'translation', es);
